import { store } from "../App";

export const displayError = (error) => {
  store.dispatch([
    {
      type: 'DISPLAY_ERROR',
      error: error ? error : ''
    }
  ]);

  setTimeout(() => {
    store.dispatch([{
      type: 'DISPLAY_ERROR',
      error: ''
    }]);
  }, 3000);
};

export const removeError = () => {
  store.dispatch([{
    type: 'DISPLAY_ERROR',
    error: ''
  }]);
};